<div class="msg" [style.height]="height + 'px'">
  <mat-error *ngIf="isShown">
    <ng-content></ng-content>
  </mat-error>
</div>
